//@flow

import { Link } from "gatsby";
import React from "react";

import ArrowForwardIcon from "@/images/ArrowForward.inline.svg";

type Props = {
    path: string,
    name: string,
    text?: string,
};

const BackNavigation = ({path, name, text}: Props): React$Element<"div"> => (
    <div className="back-navigation">
        <div className={text ? "pb-1" : "pb-3"}>
            <Link to={path}>
                <div className="d-flex">
                    <div className="svg-box icon-sm icon-mirror">
                        <div className="svg-container">
                            <ArrowForwardIcon />
                        </div>
                    </div>
                    {text && (
                        <div className="pl-3">
                            <p className="text-dark text-uppercase line-height-sm">
                                <small>{text}</small>
                            </p>
                        </div>
                    )}
                </div>
            </Link>
        </div>

        <div className={"h1 mb-0 pr-3"}>{name}</div>
    </div>
);

export default BackNavigation;
